import Vue from 'vue';
import App from './App.vue';
import VCalendar from 'v-calendar';
import Vue2Filters from 'vue2-filters'
import 'v-calendar/lib/v-calendar.min.css';
import Vuelidate from 'vuelidate';
import Axios from 'axios'
import store from './store';
import Cookie from 'js-cookie';
import router from './routes/index';
import VTooltip from 'v-tooltip';

Vue.config.productionTip = false;
Vue.use(Vue2Filters);
Vue.use(VCalendar, {});
Vue.use(Vuelidate);
Vue.use(VTooltip);

Vue.prototype.$http = Axios;
const token = Cookie.get('token')
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');